import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  currentYear = new Date().getFullYear()
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/footer/footer.component.ts